import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
export const Intro = () => {
    return (React.createElement(Box, null,
        React.createElement(Stack, { direction: "row", gap: 0.5, justifyContent: "center" },
            React.createElement(Typography, { color: "secondary", fontSize: { xs: '1.5rem', sm: '2rem' }, fontWeight: 600 }, "Unlock"),
            React.createElement(Typography, { color: "primary.dark", fontSize: { xs: '1.5rem', sm: '2rem' }, fontWeight: 600 }, "your funding potential")),
        React.createElement(Typography, { my: 1, textAlign: "center", color: "secondary.light", fontSize: "0.875rem", fontWeight: 500 }, "Your personalized grant matches are ready. Get instant access to funding opportunities worth millions.")));
};
